import axios from "axios";

export function getAdvisor() {
  return axios.get(
    `${process.env.REACT_APP_SISAPI}/v1/acropolis/academics/my-academic-advisor/`
  );
  // return axios.get(`https://sisapi.aden.org/api/v1/acropolis/pagos`);
}
